import { render, staticRenderFns } from "./FansTotal.vue?vue&type=template&id=59da01d2&"
import script from "./FansTotal.vue?vue&type=script&lang=js&"
export * from "./FansTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports